import React, { Component } from "react";
import { Modal, message } from "antd";
import ForgotPasswordModalRender from "./children/ForgotPasswordModalRender";
import ResetPasswordModalRender from "./children/ResetPasswordModalRender";
import { requsetGetCode, requsetVerifyCode, requsetResetPassword } from "../../api/apis";
import rules from "../../constants/rules";
import i18n from "../../../../locales/i18n";
import { GAForgotPasswordClickGetCode } from "../../ga/forgotPassword";

export default class ForgotAndResetPasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      findPasswordStep: "forgot", //找回密码的步骤，forgot 即当前是忘记密码获取验证码的步骤； reset 即当前是重置密码的步骤。
      codeCountDownTimeSec: 0, //验证码倒计时
      codeToken: null, //获取验证码接口返回的token
      code: null, //获取的验证码
      forgetPasswordFormSubmitting: false, //忘记密码弹窗正在提交
      resetPasswordFormSubmitting: false, //忘记密码弹窗正在提交
      email: null, //忘记密码的邮箱
    };
    this.forgetFormRef = React.createRef(); //忘记密码表单ref
    this.resetFormRef = React.createRef(); //重置密码表单ref
    this.timer = null;
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  /**
   * 点击获取验证码按钮
   */
  handleClickGetCode = () => {
    //埋点
    GAForgotPasswordClickGetCode();

    if (!this.forgetFormRef.current) {
      return false;
    }
    const emailRule = rules.email;
    this.forgetFormRef.current.validateFields(["email"]);
    const email = this.forgetFormRef.current.getFieldValue("email").replace(/(^\s*)|(\s*$)/g, "");
    if (email && email.replace(/\s+/g, "") !== "" && emailRule.test(email)) {
      this.handleRequsetGetCode(email);
      this.setState(
        {
          codeCountDownTimeSec: 60,
        },
        () => {
          this.timer = setInterval(() => {
            if (this.state.codeCountDownTimeSec <= 1) {
              clearInterval(this.timer);
            }
            this.setState({
              codeCountDownTimeSec: this.state.codeCountDownTimeSec - 1,
            });
          }, 1000);
        }
      );
    }
  };

  /**
   * 点击忘记密码弹窗提交按钮
   * @param {object} data 表单数据
   */
  handleSubmitForgetPassword = data => {
    this.setState({
      forgetPasswordFormSubmitting: true,
    });
    data.token = this.state.codeToken;
    this.handleRequsetVerifyCode(data);
  };

  /**
   * 点击重置密码弹窗提交按钮
   * @param {object} data 表单数据
   */
  handleSubmitResetPassword = data => {
    this.setState({
      resetPasswordFormSubmitting: true,
    });
    data.token = this.state.codeToken;
    data.code = this.state.code;
    this.handleRequsetResetPassword(data);
  };

  /**
   * 请求获取验证码
   * @param {string} email 邮箱地址
   */
  handleRequsetGetCode = email => {
    let formData = new FormData();
    formData.append("email", email.replace(/(^\s*)|(\s*$)/g, ""));
    requsetGetCode({
      body: formData,
    })
      .then(res => {
        if (res.code === 200) {
          message.success(i18n.t("loginAndSignUp:getCodeSuccessTips"));
          this.setState({
            codeToken: res.data.token,
          });
        } else {
          this.setState({
            codeCountDownTimeSec: 0,
          });
          if (this.timer) {
            clearInterval(this.timer);
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   *请求验证验证码
   * @param {object} data 验证接口参数
   */
  handleRequsetVerifyCode = data => {
    let formData = new FormData();
    formData.append("email", data.email.replace(/(^\s*)|(\s*$)/g, ""));
    formData.append("code", data.verification);
    formData.append("token", data.token);
    requsetVerifyCode({
      body: formData,
    })
      .then(res => {
        if (res.code === 200) {
          message.success(i18n.t("loginAndSignUp:verificationSuccessTips"));
          this.setState({
            code: data.verification,
            email: data.email,
            findPasswordStep: "reset",
          });
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
            this.setState({
              codeCountDownTimeSec: 0,
            });
          }
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          forgetPasswordFormSubmitting: false,
        });
      });
  };

  /**
   *请求重置密码
   * @param {object} data 验证接口参数
   */
  handleRequsetResetPassword = data => {
    let formData = new FormData();
    formData.append("email", data.email.replace(/(^\s*)|(\s*$)/g, ""));
    formData.append("new_password", data.newPassword);
    formData.append("new_password_confirmation", data.newPassword);
    formData.append("token", data.token);
    formData.append("code", data.code);
    requsetResetPassword({
      body: formData,
    })
      .then(res => {
        if (res.code === 200) {
          message.success(i18n.t("loginAndSignUp:resetPasswordSuccessTips"));
          this.props.handleVisible(false);
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          resetPasswordFormSubmitting: false,
        });
      });
  };

  render() {
    const { visible, handleVisible } = this.props;
    return (
      <Modal centered maskClosable={false} visible={visible} title={null} footer={null} width={500} onCancel={() => handleVisible(false)}>
        {this.state.findPasswordStep === "forgot" ? (
          <ForgotPasswordModalRender
            codeCountDownTimeSec={this.state.codeCountDownTimeSec}
            form={this.forgetFormRef}
            handleClickGetCode={this.handleClickGetCode}
            handleSubmitForgetPassword={this.handleSubmitForgetPassword}
            submitting={this.state.forgetPasswordFormSubmitting}
          />
        ) : (
          <ResetPasswordModalRender
            email={this.state.email}
            form={this.resetFormRef}
            submitting={this.state.resetPasswordFormSubmitting}
            handleSubmitResetPassword={this.handleSubmitResetPassword}
          />
        )}
      </Modal>
    );
  }
}
